import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff8dd3c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BargainPrice" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "area" }
const _hoisted_4 = { class: "bottomAction" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanList = _resolveComponent("VanList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_tabs, {
      color: "#19be6b",
      onChange: _ctx.tabChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaList, (item, key) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            title: item[1],
            name: item[0],
            key: `tabItem${key}`
          }, null, 8, ["title", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onChange"]),
    _createVNode(_component_VanList, {
      class: "list",
      listLoading: _ctx.listLoading,
      "onUpdate:listLoading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listLoading) = $event)),
      onLoad: _ctx.getList,
      "immediate-check": false,
      finished: _ctx.finished,
      "finished-text": "没有更多了"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "listItem",
            key: `item${idx}`
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(item.profile), 1),
            _createElementVNode("div", _hoisted_3, "地区: " + _toDisplayString(item.address), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.timeToNow(Number(item.createTime))), 1),
              _createVNode(_component_VanButton, {
                size: "mini",
                color: "#FFCC32",
                onClick: ($event: any) => (_ctx.$router.push({name:"DealWithDetail",query:{id:item.id}}))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["listLoading", "onLoad", "finished"])
  ]))
}